import { TrendingUp } from "lucide-react";
import { cn } from "@/lib/utils";

export const PriceChangedBadge = ({ className, testId, dark = false }) => (
  <span
    data-testid={testId}
    title="A new revision of this price list was uploaded in the last 30 days"
    className={cn(
      "ph-pulse-badge relative inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 font-mono-ph text-[10px] font-bold uppercase tracking-wider",
      dark ? "bg-[#B6FF5C] text-[#101625]" : "border border-ph-lime/50 bg-ph-lime/15 text-ph-ink",
      className,
    )}
  >
    <TrendingUp className="h-3 w-3" /> Price changed
  </span>
);
